import { useState } from "react";
import { saleAct } from "@/lib/sales";
import { SalesThumb, SalesTitle, Missing } from "@/components/sales/SalesRow";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { PackageCheck, Home as Shop, AlarmClock, ChevronDown, Undo2 } from "lucide-react";

// One part on Recommended to sell: its reasons in words, and C3's three buttons (Not this one sits inside Snooze).
const btn = "inline-flex items-center gap-1.5 h-11 px-4 rounded-lg text-sm font-bold disabled:opacity-40";
const plain = `${btn} border-2 border-slate-300 bg-white hover:bg-slate-50 text-slate-800`;

export function RecommendedRow({ r, caps, after, bar }) {
  const [busy, setBusy] = useState(false);
  const act = async (method, path, body) => {
    setBusy(true);
    bar.push(await saleAct(method, `/item/part/${r.id}${path}`, body, after, true, true));   // its words are on the Undo bar
    setBusy(false);
  };
  const label = r.code || "it";
  return (
    <div data-testid={`sales-rec-row-${r.id}`} data-back-row className="rounded-xl border border-slate-200 bg-white p-3 flex gap-3">
      <SalesThumb fileId={r.photo_file_id} testid={`sales-rec-photo-${r.id}`} />
      <div className="flex-1 min-w-0 space-y-2">
        <SalesTitle row={r} testid={`sales-rec-${r.id}`} />
        {r.back && <p data-testid={`sales-rec-back-${r.id}`} className="inline-flex items-center gap-1 text-xs font-bold text-sky-900 bg-sky-50 border border-sky-200 rounded-md px-2 py-0.5"><Undo2 className="w-3 h-3" />{r.back}</p>}
        <ul data-testid={`sales-rec-reasons-${r.id}`} className="text-sm text-slate-700 list-disc pl-4 space-y-0.5">{r.reasons.map((x) => <li key={x}>{x}</li>)}</ul>
        <Missing missing={r.missing} testid={`sales-rec-missing-${r.id}`} lead="Fix first" />
        {caps.prepare_listings && (
          <div className="flex flex-wrap gap-2">
            <button type="button" data-testid={`sales-rec-prepare-${r.id}`} disabled={busy || !r.complete}
              onClick={() => act("post", "/accept")} className={`${btn} bg-[#B01E28] hover:bg-[#8B1820] text-white`}>
              <PackageCheck className="w-4 h-4" />Prepare {label} for sale</button>
            <DropdownMenu>
              <DropdownMenuTrigger asChild>
                <button type="button" data-testid={`sales-rec-snooze-${r.id}`} disabled={busy} className={plain}>
                  <AlarmClock className="w-4 h-4" />Snooze<ChevronDown className="w-3.5 h-3.5" /></button>
              </DropdownMenuTrigger>
              <DropdownMenuContent align="start" className="min-w-[220px]">
                <DropdownMenuItem data-testid={`sales-rec-snooze-30-${r.id}`} className="h-11" onSelect={() => act("post", "/snooze", { days: 30 })}>Snooze 30 days</DropdownMenuItem>
                <DropdownMenuItem data-testid={`sales-rec-snooze-90-${r.id}`} className="h-11" onSelect={() => act("post", "/snooze", { days: 90 })}>Snooze 90 days</DropdownMenuItem>
                <DropdownMenuSeparator />
                <DropdownMenuItem data-testid={`sales-rec-not-this-one-${r.id}`} className="h-11" onSelect={() => act("post", "/not-this-one")}>Not this one — until its numbers change</DropdownMenuItem>
              </DropdownMenuContent>
            </DropdownMenu>
            <button type="button" data-testid={`sales-rec-keep-${r.id}`} disabled={busy}
              onClick={() => act("post", "/mark/keep_for_shop", {})} className={plain}>
              <Shop className="w-4 h-4" />Keep for the shop</button>
          </div>
        )}
      </div>
    </div>
  );
}
